/* globals google */

'use strict';

var markers = [];
var stores = [];
var map = null;
var geocoder;
var mapdiv = null;
var bounds;
var DEFAULT_RADIUS_TO_SEARCH_LOCATIONS = 120;
var DEFAULT_LAT = 40.4033981;
var DEFAULT_LNG = -3.7094777;
var searchBox = null;
var numStoresOfficial = 0;
var numStoresUnOfficial = 0;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

function clearMarkers() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
}

function deleteMarkers() {
    clearMarkers();
    markers = [];
}

/**
 * Prints marker in map
 */
function displayMarkers(filters) {
    numStoresOfficial = 0;
    numStoresUnOfficial = 0;

    bounds = new google.maps.LatLngBounds();

    Object.keys(mapdiv).forEach(function (key) {
        var store = mapdiv[key];
        var storeLocation = new google.maps.LatLng(store.latitude, store.longitude);

        // A marker with a custom SVG glyph.
        var glyphImg = document.createElement('img');
        glyphImg.src = $('#markerOfficialStore').prop('src');

        var glyphSvgPinElement;
        var MAX_ZINDEX = 1000;
        var borderColor;
        var background;

        function setColor(border, back) {
            borderColor = border;
            background = back;
        }

        if (store.omegaOfficialStore && store.name.includes('Pikolinos')) {
            setColor('#EA4235', '#EA4235');
        } else if (store.omegaOfficialStore || store.ID.includes('PK')) {
            setColor('#848281', '#848281');
        } else {
            setColor('#BBBBBB', '#BBBBBB');
        }

        glyphSvgPinElement = new google.maps.marker.PinElement({
            scale       : store.omegaOfficialStore ? 1.5 : 1.0,
            glyph       : glyphImg,
            borderColor : borderColor,
            background  : background
        });

        var marker = new google.maps.marker.AdvancedMarkerElement({
            map      : map,
            position : storeLocation,
            content  : glyphSvgPinElement.element,
            title    : store.name
        });

        store.omegaOfficialStore ? marker.zIndex = MAX_ZINDEX + 1 : marker.zIndex = MAX_ZINDEX;

        store.marker = marker;
        stores.push(store);
        markers.push(marker);
        marker.addListener('click', function () {
            var id = '#viewStore' + store.ID;
            var modal = $(id);
            var body = modal.find('div.modal-body').html();
            $('#viewStore div.modal-body').empty().html(body);
            $('#viewStore').modal('show');
        });

        if (store.omegaOfficialStore) {
            numStoresOfficial += 1;
        } else {
            numStoresUnOfficial += 1;
        }

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });

    if (!filters) {
        if (numStoresOfficial === 0) {
            $('#stores').prop('checked', false);
            $('#stores').attr('disabled', true);
            $('#stores').parent().addClass('disabled');
        } else {
            $('#stores').prop('checked', true);
            $('#stores').attr('disabled', false);
            $('#stores').parent().removeClass('disabled');
        }
        if (numStoresUnOfficial === 0) {
            $('#otherStores').prop('checked', false);
            $('#otherStores').attr('disabled', true);
            $('#otherStores').parent().addClass('disabled');
        } else {
            $('#otherStores').prop('checked', true);
            $('#otherStores').attr('disabled', false);
            $('#otherStores').parent().removeClass('disabled');
        }
    }

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    } else {
        $('.modal-no-results').modal('show');
    }
}

/**
 * Update results of the map
 */
function updateStores(obj, filters) {
    mapdiv = obj;
    deleteMarkers();
    stores = [];
    displayMarkers(filters);
}

/**
 * Get addres by latitude and longitude using google maps api
 * * @param {float} lat - latitude
 * * @param {float} lng - longitude
 */
function getAddressFromLatLang(lat, lng) {
    var latlng = {
        lat : lat,
        lng : lng
    };
    geocoder.geocode({
        location: latlng
    }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            if (results.length > 0) {
                var locality;
                var country;
                var countryCode;
                var distanceUnit;
                var arrAddress = results[0].address_components;
                Object.keys(arrAddress).forEach(function (key) {
                    var address_component = arrAddress[key];
                    if (address_component.types[0] == 'locality') {
                        locality = address_component.long_name;
                    } else if (address_component.types[0] == 'country') {
                        country = address_component.long_name;
                        countryCode = address_component.short_name;
                    }
                    if (locality && country) {
                        $('#storeLocator-Location').empty().html(locality + ', ' + country);
                        if ($('#storeLocator-Radius').is(':empty')) {
                            distanceUnit = countryCode === 'US' ? 'mi' : 'km';
                            $('#storeLocator-Radius').html(DEFAULT_RADIUS_TO_SEARCH_LOCATIONS + ' ' + distanceUnit);
                        }
                        $('.store-search-resuls').removeClass('d-none');
                        return false;
                    }
                });
            }
        }
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 * @param {Boolean} filters - true if search with click checks
 */
function updateStoresResults(data, filters) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        var obj = $('.map-canvas').attr('data-locations');
        if (obj !== null && obj !== 'null') {
            obj = JSON.parse(obj);
        }
        updateStores(obj, filters);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

function findStores(latitude, longitude) {
    var $detectLocationButton = $('.detect-location');
    var url = $detectLocationButton.data('action');
    var radius = DEFAULT_RADIUS_TO_SEARCH_LOCATIONS;
    $('#otherStores').prop('checked', true);
    $('#stores').prop('checked', true);
    var urlParams = {
        radius : radius,
        lat    : latitude,
        long   : longitude
    };

    getAddressFromLatLang(latitude, longitude);
    $.spinner().start();
    url = appendToUrl(url, urlParams);
    $.ajax({
        url      : url,
        type     : 'get',
        dataType : 'json',
        success  : function (data) {
            $.spinner().stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Search stores by latitude and longitude
 * If have params, search with these, else search wit geolocation
 * * @param {float} latitude
 * * @param {float} longitude
 */
function searchStores(latitude, longitude) {
    if (latitude && longitude) {
        findStores(latitude, longitude);
    } else {
        if (!navigator.geolocation) {
            $.spinner().stop();
            return;
        }
        var geoSettings = {
            enableHighAccuracy : false,
            maximumAge         : 30000,
            timeout            : 20000
        };
        navigator.geolocation.getCurrentPosition(function (position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            findStores(lat, lng);
        }, function () {
            $.spinner().stop();
        }, geoSettings);
    }
}

/**
 * Search latitud and longitud using value of postal code (address)
 * If have params, search with these, else search wit geolocation
 * * @param {String} value - address
 */
function geoCode(value) {
    geocoder.geocode({
        address: value
    }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            getAddressFromLatLang(lat, lng);
            searchStores(lat, lng);
        }
    });
}

function getSearchboxElement() {
    var searchBoxElement = document.getElementById('store-postal-code');
    return searchBoxElement;
}

/**
 * Get address using geolocation
 */
function geoUserLocation() {
    if (!navigator.geolocation) {
        $.spinner().stop();
        return;
    }
    navigator.geolocation.getCurrentPosition((function (position) {
        map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
        getAddressFromLatLang(position.coords.latitude, position.coords.longitude);
    }));
}

/**
 * Event to search locations when change postal code (address)
 */
function placesChanged() {
    geoCode(getSearchboxElement().value);
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var latlng = new google.maps.LatLng(DEFAULT_LAT, DEFAULT_LNG);
    var mapOptions = {
        mapId            : 'MAP_ID', // Map ID is required for advanced markers.
        center           : latlng,
        zoom             : 4,
        maxZoom          : 20,
        disableDefaultUI : true,
        zoomControl      : true
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    geocoder = new google.maps.Geocoder();
    searchBox = new google.maps.places.SearchBox(getSearchboxElement());
    searchBox.addListener('places_changed', function () {
        placesChanged();
    });

    mapdiv = $('.map-canvas').attr('data-locations');
    if (mapdiv !== null && mapdiv !== 'null') {
        mapdiv = JSON.parse(mapdiv);
        displayMarkers(false);
    }

    geoUserLocation();
}

function getUrlParams() {
    var storesChecked = $('#stores').is(':checked');
    var otherStoresChecked = $('#otherStores').is(':checked');
    var searchKeys = $('.results').data('search-key');
    var urlParams = {};
    var radius = DEFAULT_RADIUS_TO_SEARCH_LOCATIONS;
    if (searchKeys.postalCode) {
        urlParams = {
            radius             : radius,
            postalCode         : searchKeys.postalCode,
            storesChecked      : storesChecked,
            otherStoresChecked : otherStoresChecked
        };
    } else if (searchKeys.lat && searchKeys.long) {
        urlParams = {
            radius             : radius,
            lat                : searchKeys.lat,
            long               : searchKeys.long,
            storesChecked      : storesChecked,
            otherStoresChecked : otherStoresChecked
        };
    }
    return urlParams;
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }
        $('.store-locator-no-results').hide();
        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
        searchStores();
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('touchstart click', function () {
            searchStores();
        });
    },

    search: function () {
        $('.store-locator-container div.store-locator').submit(function (e) {
            e.preventDefault();
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            placesChanged();
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('touchstart click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID          : selectedStore.val(),
                searchRadius     : $('#radius').val(),
                searchPostalCode : $('.results').data('search-key').postalCode,
                storeDetailsHtml : selectedStore.siblings('label').find('.store-details').html(),
                event            : e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },
    selectView: function () {
        $('.store-locator-filters').on('touchstart click', '.tabs-btn', function (e) {
            e.preventDefault();
            var id = $(this).attr('rel');
            $('.tabs-btn').removeClass('active');
            $(this).addClass('active');
            $('.store-view').hide();
            $('#' + id).show();
            // Fit the all the store marks in the center of a minimum bounds when any store has been found.
            if (id === 'store-map' && mapdiv && mapdiv.length !== 0 && bounds) {
                map.fitBounds(bounds);
            }
        });
    },
    checkFilter: function () {
        $('#stores, #otherStores').change(function (e) {
            e.preventDefault();
            var url = $(this).data('action-url');
            var urlParams = getUrlParams();

            url = appendToUrl(url, urlParams);
            // $.spinner().start();
            $.ajax({
                url      : url,
                type     : 'get',
                dataType : 'json',
                success  : function (data) {
                    // $.spinner().stop();
                    var filters = true;
                    updateStoresResults(data, filters);
                    $('.select-store').prop('disabled', true);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
